// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import ProductDetailPage from '@/pages/products/components/_ProductDetailPage.vue'
import i18n from '@/lang/i18n.ts'

hybridPage()

const app = createApp({
	name: 'PCSDetailPage',
	components: {
		ProductDetailPage,
	},
	setup() {},
})

app.use(i18n)
app.mount('#bsMain')
